<template>
  <div class="flex flex-col">
    <Header />
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { mapGetters } from "vuex";

export default {
  name: "MainLayout",
  components: { Header }
};
</script>
